// extracted by mini-css-extract-plugin
export default {"copy-icon":"CopyBtn_copy-icon__8jX63","copy-icon-one":"CopyBtn_copy-icon-one__NtsMP","copy-message":"CopyBtn_copy-message__YMBWw","fade-out":"CopyBtn_fade-out__w1U0q"};